import GradeBenefitContainer from './GradeBenefitContainer';
export default GradeBenefitContainer;
